import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-report-statement',
  templateUrl: './report-statement.component.html',
  styleUrls: ['./report-statement.component.scss']
})
export class ReportStatementComponent {

  selectedReasons: { [uuid: string]: boolean } = {};
  otherSelected = false;
  otherReason = '';
  canSubmit = false;

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private dialogRef: MatDialogRef<any>
  ) { }

  toggleReason(uuid: string) {
    this.selectedReasons[uuid] = !this.selectedReasons[uuid];
    this.refreshCanSubmit();
  }

  toggleOther() {
    this.otherSelected = !this.otherSelected;
    if (!this.otherSelected) {
      this.otherReason = '';
    }
    this.refreshCanSubmit();
  }

  onOtherReasonChange() {
    this.refreshCanSubmit();
  }

  close(submit: boolean) {
    if (!submit) {
      this.dialogRef.close({btnValue: false});
      return;
    }

    this.dialogRef.close({
      btnValue: true,
      reasonUuids: this.getSelectedReasonUuids(),
      otherReason: this.otherSelected ? this.otherReason.trim() : null
    });
  }

  private getSelectedReasonUuids(): string[] {
    return (this.data.reasons ?? [])
      .filter((reason: any) => this.selectedReasons[reason.uuid])
      .map((reason: any) => reason.uuid);
  }

  private refreshCanSubmit() {
    this.canSubmit = this.getSelectedReasonUuids().length > 0
      || (this.otherSelected && this.otherReason.trim().length > 0);
  }

}
